import axios from 'axios';
import constants from '../constants';

const MEMBERS_PATH = constants.urlPrefix + '/api/members';
const MEMBER_PATH = '/app/member';
const LOGIN_PATH = '/app/member/account/authenticate/sso/auth';
const DIRECT_LOGIN_PATH = constants.urlPrefix + '/api/account/authenticate/sso/direct';
const MEMBER_LOGIN_PATH = constants.urlPrefix + '/api/members/login';
const LOGIN_CHECK_PATH = 'api/account/authenticate/check';

const validateData = (data) => axios.post(MEMBERS_PATH + '/validate/data', data);

const login = (email, password, server) => {
    const data = new FormData();
    data.append('data', JSON.stringify({ email, password, server }));
    return axios.post(LOGIN_PATH, data);
}

const directLogin = (params) => {
    return axios.post( `${DIRECT_LOGIN_PATH}?${params}`);
}

const timberLogin = (id, email, password) => {;
    return axios.post(MEMBER_LOGIN_PATH, { id, email, password })
}

const checkLogin = () => {
	return axios.get(LOGIN_CHECK_PATH, {})
}

const sendWelcomeEmail = (id) => axios.post(MEMBER_PATH + '/email/welcome/' + id);

const getByTemplateUsage = (id) => axios.get(MEMBERS_PATH + '/usingTemplate/' + id);

const getByCustomSizeUsage = (id) => axios.get(MEMBERS_PATH + '/usingCustomSize/' + id);

const uploadMemberQRCode = (memberId, formData) => axios.post(`${MEMBERS_PATH}/${memberId}/qrcodes/upload`, formData);

const getUsersCount = (memberId) => axios.get(`${MEMBERS_PATH}/${memberId}/users/count`);

export default {
    validateData,
    login,
    directLogin,
    timberLogin,
    sendWelcomeEmail,
    getByTemplateUsage,
    getByCustomSizeUsage,
    checkLogin,
    uploadMemberQRCode,
    getUsersCount,
}
